import { useCurrentUser, useFriends } from "@/data/hooks";
import { Id } from "@/data/types";
import { cleanFriends } from "@/data/redux/user";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { RoutePaths } from "@/views/routes";
import Button from "@/views/Components/Button";
import { toggleFriend } from "@/data/firebase/friends";
import { useState } from "react";

interface Props {
  uid: Id;
  className?: string;
}
export default function ToggleFriendButton({ uid, className }: Props) {
  const friends: Id[] | undefined = useFriends();
  const { user } = useCurrentUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [toggleLoading, setToggleLoading] = useState(false);

  const isMyFriend =
    typeof friends !== "undefined" && friends.indexOf(uid) !== -1;
  const onToggleFriend = async () => {
    if (!user) {
      navigate(RoutePaths.login);
      return;
    }
    setToggleLoading(true);
    await toggleFriend(uid, !isMyFriend);
    dispatch(cleanFriends());
    setToggleLoading(false);
  };
  return (
    <Button
      lighter={isMyFriend}
      onClick={onToggleFriend}
      loading={toggleLoading}
      className={className}
    >
      {isMyFriend ? "Remove friend" : "Add friend"}
    </Button>
  );
}
